<template>
  <div class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">
    <sidebar :routes="myRoutes" class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <tags-view></tags-view>
      <el-alert
        v-show="isShow_MyPay_Setting && isNotShopDetai"
        title="go set"
        type="warning"
        show-icon
        >
        <template slot="title">
           <span v-if="this.$i18n.locale == 'zh'" style="color: #606266;">
            请完善点击
            <a @click="RouteMiepaySetting" style="color: #409EFF;">{{generateCustomizeString('here')}}</a>完善MiePay的支付设置。
          </span>
          <span v-if="this.$i18n.locale == 'en'" style="color: #606266;">
            Please Click
            <a @click="RouteMiepaySetting" style="color: #409EFF;">{{generateCustomizeString('here')}}</a> to set up MiePay payment.
          </span>
        </template>
      </el-alert>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Navbar, Sidebar, AppMain, TagsView } from '@/views/layout/components'
import request from '@/utils/request'
import { menu } from '@/utils/menu'
import cookie from 'js-cookie'
import { mapGetters } from 'vuex'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView
  },
  data() {
    return {
      myRoutes: [],
      myMenus: [],
      menusLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'isShow_warehouses_badge',
      'isShow_brands_badge',
      'isShow_discountPlans_badge',
      'isShow_categories_badge',
      'isShow_MyPay_Setting'
    ]),
    isNotShopDetai() {
      if (this.$route.name != 'ShopDetail') {
        return true
      }
      return false
    },
    sidebar() {
      return this.$store.state.app.sidebar
    },
    routes() {
      const globalMenu = cookie.get('globalMenu')
      if (globalMenu) {
        return menu(JSON.parse(globalMenu))
      }
      return []
    }
  },
  methods: {
    generateCustomizeString,
    RouteMiepaySetting() {
      if (this.$route.name == 'ShopDetail') {
        return
      }
      this.$router.push({ name: 'ShopDetail', params: { activeName: '3' }})
    },
    updateRoutes() {
      if (this.myMenus.length > 0) {
        const routes = this.routes
        this.myRoutes = routes.map(route => {
          // 父节点有权限，代表所有子节点一定有权限
          // 父节点没有权限，可能因为子节点有权限而要开放
          if (route.children) {
            route.children.map(child => {
              if (child.name == 'Brand') {
                child.meta.badge = this.isShow_brands_badge
              }
              if (child.name == 'Categories') {
                child.meta.badge = this.isShow_categories_badge
              }
              if (child.name == 'Warehouse') {
                child.meta.badge = this.isShow_warehouses_badge
              }
              if (child.name == 'DiscountPlanList') {
                child.meta.badge = this.isShow_discountPlans_badge
              }
            })
          }
          if (this.myMenus.indexOf(route.name) < 0) {
            route.hidden = true
            if (route.children) {
              route.children.map(child => {
                if (this.myMenus.indexOf(child.name) < 0) {
                  child.hidden = true
                } else {
                  // 有一个有权限，则主节点不需要隐藏
                  route.hidden = false
                }
              })
            }
          }
          return route
        })
      } else {
        this.myRoutes = []
      }
    },
    fetchMenus() {
      if (this.menusLoading) return
      this.menusLoading = true
      request({
        url: 'permission/my/menu/list',
        method: 'get'
      }).then(response => {
        this.myMenus = response.data
        this.updateRoutes()
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.menusLoading = false
      })
    }
  },
  created() {
    if (this.routes.length < 1) {
      this.$router.push({ path: 'login' })
    }
    this.fetchMenus()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/mixin.scss';
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
